import React, { FC, memo } from 'react';
import {
    M130ProductDetailModule,
    M131ProductDetailModule,
    ProductViewModel,
} from '~/lib/data-contract';

import { useProduct } from '~/shared/utils/product/hooks/useProduct';
import ProductDetails from './product-details.component';
import { ProductErrorResponse } from '~/shared/utils/product/data-models';
import ProductErrorPage from '../product-error-page/product-error-page.component';

type Props = M130ProductDetailModule | M131ProductDetailModule;

const ProductDetailDataWrapper: FC<Props> = memo((props) => {
    const { data } = useProduct();

    if (!data) {
        return null;
    }

    if ((data as ProductErrorResponse).statusCode === 404) {
        return <ProductErrorPage {...(data as ProductErrorResponse)} />;
    }

    return <ProductDetails {...props} product={data as ProductViewModel} />;
});

ProductDetailDataWrapper.displayName = 'ProductDetailDataWrapper';
export default ProductDetailDataWrapper;
